import React from 'react';
import { MessageCircle } from 'lucide-react';
import { businessInfo } from '../mock';

const WhatsAppButton = () => {
  const whatsappUrl = `https://wa.me/${businessInfo.whatsapp}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 w-16 h-16 bg-[#FFC222] hover:bg-[#E6AE12] rounded-full flex items-center justify-center shadow-2xl transition-all duration-300 hover:scale-110 z-50 group"
      aria-label="Contact us on WhatsApp"
    >
      <MessageCircle className="w-8 h-8 text-black" />
      <span className="absolute right-20 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        Chat on WhatsApp
      </span>
    </a>
  );
};

export default WhatsAppButton;
